import { useAppStore } from "store/store";
import { getGeneralAnalyticsParams } from "./useGeneralAnalytics";
import useMutatedPagePath from "./useMutatedPagePath";
import { useEffect } from "react";
import AnalyticsService from "services/analytics/analytics";

const useUploadAnalytics = (itemType: string) => {
  const locale = useAppStore((state) => state.locale);
  const [path, title, location] = useMutatedPagePath();
  const paxSessions = useAppStore((state) => state.paxSessions);
  const journey = useAppStore((state) => state.journey);

  useEffect(() => {
    AnalyticsService.shared.trackEvent(
      "upload_selected",
      {
        ...getGeneralAnalyticsParams(
          paxSessions,
          journey,
          path,
          title,
          location,
          locale
        ),
        item_type: itemType,
      },
      false // isScanRelated
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useUploadAnalytics;
